import React from 'react';
import PaywallRowItem from '../row-item';
import PaywallGroupHeader from './components/group-header';
import { PAYWALL_BODY_PROP_TYPES } from './constants';

const defaultAvailablePlans = [];

const PaywallBody = ({
  data,
  isLoading = false,
  highlightedElementId = '',
  onTooltipHover = Function.prototype,
  groupTitle = '',
  availablePlans = defaultAvailablePlans,
}) => {
  const withHeader = groupTitle || !!availablePlans.length;

  return (
    <React.Fragment>
      {withHeader && <PaywallGroupHeader groupTitle={groupTitle} availablePlans={availablePlans} />}
      {data.map(({ id, ...rowData }) => (
        <PaywallRowItem
          {...rowData}
          loading={isLoading}
          highlightedElementId={highlightedElementId}
          key={id}
          onTooltipHover={() => onTooltipHover(id)}
        />
      ))}
    </React.Fragment>
  );
};

PaywallBody.propTypes = PAYWALL_BODY_PROP_TYPES;

export default PaywallBody;
